<script lang="ts">
  import { link } from "svelte-routing"
  import { Button, Col, Row } from "sveltestrap"
  import AcceptModal from "./AcceptModal.svelte"
  import Image from "./Image.svelte"
  import { metaNftAcceptable, metaNfts, multipliers, nftAcceptable, tokenPrice } from "../stores/store"
  import { nFormatter } from "../utils/utils"
  import PilTooltip from "./PilTooltip.svelte"
  import { connected, chainId, selectedAccount, web3 } from "svelte-web3"
  import { COREABI } from "../abis/core"
  import { ZERO_ADDRESS } from "../stores/constants"
  import { CONFIG } from "../config"
  import TxModal from "./TxModal.svelte"

  export let data = [];
  let columns = ['Item', 'Title', 'NFT Price', 'Mined PIL', 'PIL APY', 'Multiplier', 'Action'];

  let tooltips = {
    'NFT Price': 'This is the price of the entire NFT buyout.',
    'PIL APY': 'Annualized PIL returns from this pool.',
    'Multiplier': 'Rewards multiplier over base PIL emissions for this pool.',
  };

  let txHash = '';

  let claimTxModalOpen = false;

  const claim = (metaNftId: number) => {
    return async () => {
      const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
      pilgrim.methods.claimPairReward(metaNftId).send({ from: $selectedAccount })
        .on('transactionHash', hash => {
          console.log(hash);
          txHash = hash;
          claimTxModalOpen = true;
        })
        .on('receipt', receipt => {
          console.log(receipt);
        })
    }
  }

  const pollNftBid = async (metaNftId: number) => {
    const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
    const res = await pilgrim.methods.pollNftBid(metaNftId).call();
    $nftAcceptable[metaNftId] = res[0] !== ZERO_ADDRESS;
  }

  const pollMetaNftBid = async (metaNftId: number) => {
    const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
    const res = await pilgrim.methods.pollMetaNftBid(metaNftId).call();
    $metaNftAcceptable[metaNftId] = res[0] !== ZERO_ADDRESS;
  }

  $: if($connected) {
    for (let row of data) {
      pollNftBid(row.metaNftId);
      pollMetaNftBid(row.metaNftId);
    }
  }
</script>

<table class="pil-table">
  <thead>
  <tr>
    {#each columns as column}
      <th class={'table-header ' + (column === 'Title' ? 'table-title' : '')}>
        {column}
        {#if tooltips.hasOwnProperty(column)}
          <PilTooltip tooltipId={`pos-metanft-${column.replace(/ /i, '-')}`}>{tooltips[column]}</PilTooltip>
        {/if}
      </th>
    {/each}
  </tr>
  </thead>
  <tbody>
  {#each data as row}
    <tr>
      <td class="table-thumbnail-col">
        <a href={`/nft/${row.metaNftId}`} use:link>
          <Image src={row.image} table={true}/>
        </a>
      </td>
      <td class='table-title'>
        <a class="table-title-link" href={`/nft/${row.metaNftId}`} use:link>
          {row.title}
        </a>
      </td>
      <td>
        {nFormatter(row.nftPrice, 2)} {row.baseToken}
        {#if row.nftPriceDelta >= 0}
          <span class="positive">
            &nbsp;&nbsp;+{nFormatter(row.nftPriceDelta, 2)} ({(row.nftPriceDelta / (row.nftPrice - row.nftPriceDelta) * 100).toFixed(2)}%)
          </span>
        {:else}
          <span class="negative">
            &nbsp;&nbsp;-{nFormatter(row.nftPriceDelta, 2)} ({(row.nftPriceDelta / (row.nftPrice - row.nftPriceDelta) * -100).toFixed(2)}%)
          </span>
        {/if}
<!--        <span class={row['NFT Price'].delta > 0 ? 'positive' : 'negative'}>-->

<!--        </span>-->
      </td>
      <td>
        {nFormatter(row.pairReward, 2)} PIL
        {#if row.pairReward > 0}
          <Button class="button-fill pf-table-action-button" on:click={claim(row.metaNftId)}>Claim</Button>
        {/if}
      </td>
      <td>
        {nFormatter(row.yearPairRewardPerRound * $tokenPrice.PIL / (row.listingPrice * $tokenPrice[row.baseToken]) * 100, 2)}%
      </td>
      <td>
        {$multipliers[row.baseToken]}x
      </td>
      <td class="table-action">
        {#if $nftAcceptable.hasOwnProperty(row.metaNftId) && $nftAcceptable[row.metaNftId]}
          <Row class="col-auto">
            <Col>
              <AcceptModal action="NFT" data={row}/>
            </Col>
          </Row>
        {/if}
        {#if $metaNftAcceptable.hasOwnProperty(row.metaNftId) && $metaNftAcceptable[row.metaNftId]}
          <Row class="col-auto">
            <Col>
              <AcceptModal action="MetaNFT" data={row}/>
            </Col>
          </Row>
        {/if}
        <!--{#each row['action'] as action}-->
        <!--  <Row class="col-auto">-->
        <!--    <Col>-->
        <!--      <AcceptModal action={action}/>-->
        <!--    </Col>-->
        <!--  </Row>-->
        <!--{/each}-->
      </td>
    </tr>
  {/each}
  </tbody>
</table>
<TxModal msg="Claim transaction initiated" txHash={txHash} isOpen={claimTxModalOpen}/>
